import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Bestil printprodukter',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Produktdetaljer',
    [ProductOrderingSteps.ShippingInfo]: 'Forsendelsesinfo',
    payment: 'Betaling',
  },
  form: {
    title: 'Ordredetaljer',
    polygraphy_product_id: {
      label: 'Produkt',
      placeholder: 'Vælg produkt',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Flyer - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Skabelon #1 🆕',
            [FlyerTemplate.Two]: 'Skabelon #2 🆕',
            [FlyerTemplate.Three]: 'Skabelon #3',
            [FlyerTemplate.Four]: 'Skabelon #4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Klistermærke - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Skabelon #1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Dørklistermærke - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Skabelon #1 🆕',
            [DoorStickerTemplate.Two]: 'Skabelon #2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Antal',
      placeholder: 'Indtast antal',
    },
    service_level: {
      label: 'Serviceniveau',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Spar',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Standard',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Express',
      },
    },
    shipping_company_name: {
      label: 'Virksomhed',
      placeholder: 'Indtast virksomhedsnavn',
    },
    shipping_salutation: {
      label: 'Titel',
      options: {
        mr: 'Hr.',
        mrs: 'Fru',
      },
    },
    shipping_first_name: {
      label: 'Fornavn',
      placeholder: 'Indtast fornavn',
    },
    shipping_last_name: {
      label: 'Efternavn',
      placeholder: 'Indtast efternavn',
    },
    shipping_country: {
      label: 'Land',
      placeholder: 'Vælg land',
    },
    shipping_state: {
      label: 'Region',
      placeholder: 'Vælg region',
    },
    shipping_city: {
      label: 'By',
      placeholder: 'Indtast by',
    },
    shipping_address: {
      label: 'Adresse',
      placeholder: 'Indtast adresse',
    },
    shipping_zip_code: {
      label: 'Postnummer',
      placeholder: 'Indtast postnummer',
    },
    shipping_phone_number: {
      label: 'Telefonnummer',
      placeholder: 'Indtast telefonnummer',
    },
    create_invoice: {
      options: {
        true: 'Fakturer automatisk - Bliv debiteret med det samme',
        false: 'Send gratis - Dette er en gave',
      },
    },
  },
  table: {
    title: 'Tidligere ordrer',
    fields: {
      product: 'Produkt',
      quantity: 'Antal',
      status: 'Status',
      service_level: 'Serviceniveau',
      shipping: 'Forsendelse',
      tracking_url: 'Sporings-URL',
      created: 'Oprettet',
      updated: 'Sidst opdateret',
    },
  },
  labels: {
    shipping_company: 'Virksomhed',
    shipping_salutation: 'Titel',
    shipping_first_name: 'Fornavn',
    shipping_last_name: 'Efternavn',
    shipping_address: 'Adresse',
    shipping_zip_code: 'Postnummer',
    shipping_city: 'By',
    shipping_phone_number: 'Telefonnummer',
    show_shipping_details: 'Forsendelsesdetaljer',
    track_order: 'Spor ordre',
    pending_from_provider: 'Afventer fra leverandør',
  },
  modals: {
    confirmation: {
      title: 'Bekræft ordredetaljer',
    },
    free_order_confirmation: {
      title: 'Er du sikker på, at du vil sende {{product}} gratis?',
      description: 'Du har valgt ikke at opkræve betaling fra din kunde i dag.\n Produktet sendes uden betaling.',
      buttons: {
        confirm: 'Ja, send gratis',
      },
    },
  },
  buttons: {
    back_to_templates: 'Tilbage til skabeloner',
    preview: 'Forhåndsvisning',
    next: 'Næste',
    order: 'Opret ordre',
    confirm: 'Bekræft',
  },
  feedback: {
    shop_url_used: 'Produktet indeholder onlineshoppens URL (<url>{{url}}</url>). Er det med vilje?',
    order_total_price: 'Samlet pris for de valgte produkter: <strong>{{amount}} netto</strong>',
  },
  toasts: {
    failed_to_create_order: 'Ordren kunne ikke oprettes',
    order_got_created: 'Ordren er oprettet',
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
